import React from 'react';
import './LoaderComponent.scss';

export const LoaderComponent = () => {
  return (
    <div className="loader-container">
      <div className="loader-container-content">
        <div className="loader-logo-container">
          <img className="loader-logo-img-1" src="/images/logo/logo1.png" alt="logo" />
        </div>

        <div class="btn-shine" target="_blank">
          LEO CLUB OF <br /> COLOMBO MONARCH
        </div>

        <div className="loader-logo-container-bottom">
          <img className="loader-logo-img-1" src="/images/logo/logo1-bottom.png" alt="logo" />
        </div>
        <div className="loader-shrimmer-wrapper">
          <div className="loader-logo-shrimmer"></div>
        </div>
      </div>
    </div>
  );
};